import * as React from 'react';
import { ConfigContext } from 'modules/context';

import Button from 'components/button';
import Spinner from 'components/spinner';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';

import { ILoginSession } from 'types/session';
import { IGenericFunction } from 'types/generics';

import { TEXT_KEYS } from './platform-first-landing.constants';

import './landing.styles.less';

export class PlatformFirstLanding extends React.Component<ILandingProps> {
    public componentDidUpdate(): void {
        if (this.props.loginSession) {
            this.props.broadcastHasSession();
        }
    }

    public handleLoginClick = (): void => {
        this.props.goToLoginPage();
    };

    public render(): JSX.Element {
        const { getModeClass } = this.context;
        const { dangerouslyTranslateWithHTML: translateKey, fetching } = this.props;

        if (fetching) {
            return <Spinner />;
        }

        const landingTitleText: string = translateKey(TEXT_KEYS.LANDING_TITLE);
        const landingDescriptionText: string = translateKey(TEXT_KEYS.LANDING_DESCRIPTION);
        const loginButtonText: string = translateKey(TEXT_KEYS.LOGIN_BUTTON);

        return (
            <div className={getModeClass('sitegen-landing')}>
                <div className={getModeClass('sitegen-landing__title')}>{landingTitleText}</div>
                <div className={getModeClass('sitegen-landing__description')}>{landingDescriptionText}</div>
                <Button onClick={this.handleLoginClick}>
                    {loginButtonText}
                </Button>
            </div>
        );
    }
}

PlatformFirstLanding.contextType = ConfigContext;

export interface ILandingStoreProps {
    readonly fetching: boolean;
    readonly loginSession: ILoginSession | null;
}

export interface ILandingDispatchProps {
    readonly goToLoginPage: IGenericFunction<void, React.SyntheticEvent<HTMLButtonElement>>;
    readonly broadcastHasSession: IGenericFunction<void>;
}

export type ILandingProps = ILandingStoreProps & ILandingDispatchProps & ITranslationProps;
export default translate()(PlatformFirstLanding);
